import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "16",
  height: "16",
  x: "2",
  y: "2",
  fill: "#1564C0",
  rx: "2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "m8.379 12.098 1.133-4.786h.633l.144.797L9.082 13h-.68zm-.582-4.786.937 4.786-.078.902h-.758L6.637 7.313zm3.488 4.766.926-4.765h1.16L12.113 13h-.758zM10.5 7.313l1.14 4.804-.03.883h-.68L9.715 8.105l.156-.793z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }